

import React, { useRef } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "./SnackbarContext";

function UploadCard({
  documentType = "",
  heading = "",
  doc_name = "",
  onFileSelect,
  fileUploaded = false,
  fileUrl,
  hasError  =false
}) {
  const fileInputRef = useRef();
const showSnackbar = useSnackbar();
  const handleCardClick = () => fileInputRef.current?.click();

 const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg"];
  const maxFileSize = 1 * 1024 * 1024; // 5 MB

  if (!allowedTypes.includes(file.type)) {
    showSnackbar("Only PDF, JPG, or JPEG files are allowed", "error");
    return;
  }

  if (file.size > maxFileSize) {
    showSnackbar("File must be less than 1 MB", "error");
    return;
  }

  onFileSelect?.(file, doc_name);
};

  return (
    <div
      // className={`flex h-[150px] w-full max-w-[380px] md:max-w-[320px] border ${fileUploaded ? 'border-green-500' : 'border-[#f2f2f2]'} rounded-[10px] py-6 pl-7 pr-7 shadow-md cursor-pointer`}
      className={`flex h-[150px] bg-white w-[300px] md:w-[320px] 
    border 
    ${
      hasError
        ? "border-red-500"
        : fileUploaded
        ? "border-green-500"
        : "border-[#f2f2f2]"
    } 
    rounded-[10px] py-6 pl-7 pr-7 shadow-md cursor-pointer`}
      onClick={handleCardClick}
    >
      <input
        type="file"
        ref={fileInputRef}
        accept=".pdf, .jpg, .jpeg"
        className="hidden"
        onChange={handleFileChange}
      />

      <div className="mt-3">
        <div
          className={`flex justify-center items-center h-[40px] w-[40px] rounded-full ${
            fileUploaded ? "bg-green-100" : "bg-[#F9FDFF]"
          }`}
          style={{
            boxShadow:
              "0 -1px 1px rgba(0,0,0,0.05), 0 3px 12px rgba(0,0,0,0.4)",
            transition: "box-shadow 0.3s ease",
          }}
        >
          <FileUploadIcon
            className={`${fileUploaded ? "text-green-700" : "text-[#3587B8]"}`}
          />
        </div>
      </div>

      <div className="ml-2">
        <div className="text-[20px] md:text-base text-[#222222] font-[600]">
          {heading}
        </div>

        {fileUploaded ? (
          <div className="text-green-700 text-sm mt-1 font-medium">
            ✓ File uploaded
          </div>
        ) : (
          <div className="text-[14px] md:text-[10px] text-[#565656]">
            <span className="underline underline-offset-1 font-[500]">
              Click to upload
            </span>{" "}
            or drag and drop
          </div>
        )}

        <div className="text-[13px] md:text-[10px] text-[#565656] mt-1">
          {documentType}
        </div>
      </div>
    </div>
  );
}

export default UploadCard;
